// extracted by mini-css-extract-plugin
export var legendIndicator = "_bz-1";
export var legendRight = "_bz-0";